<template>
  <div id="rateassist-accessorials">
    <div class="row">
      <div class="col-xs-12">
        <blockquote>
          Add an Accessorial
          <div class="btn btn-primary sq pull-right" @click="addRow">
            Add
          </div>
        </blockquote>
      </div>
      <div class="col-xs-12" v-for="(acc, i) in accessorials">
        <div class="shadow clearfix">
          <hr class="hr-text" :data-content="`ACCESSORIAL ${i + 1}`"/>
          <div class="col-xs-12 col-sm-6 col-md-4">
            <div class="form-group">
              <label :for="'acc-fc-' + i" class="form-label">Financial Code</label>
              <select v-model="acc.financialCode" class="form-control" :id="'acc-fc-' + i">
                <option value=""></option>
                <option v-for="option in financialCodes" :value="option.id">{{ option.name }}</option>
              </select>
            </div>
          </div>
          <div class="col-xs-12 col-sm-6 col-md-4">
            <div class="form-group">
              <label :for="'acc-sc-' + i" class="form-label">Static Cost</label>
              <input type="text" v-model="acc.description" class="form-control" :id="'acc-sc-' + i"/>
            </div>
          </div>
          <div class="col-xs-12 col-sm-6 col-md-4">
            <div class="form-group">
              <label :for="'acc-am-' + i" class="form-label">Amount</label>
              <input type="number" step="0.01" v-model="acc.rate" class="form-control" :id="'acc-am-' + i"/>
            </div>
          </div>
          <div class="col-xs-12 col-sm-6 col-md-4">
            <div class="form-group">
              <label :for="'acc-cur-' + i" class="form-label">Currency</label>
              <select v-model="acc.rateCurrency" class="form-control" :id="'acc-cur-' + i">
                <option value=""></option>
                <option v-for="option in currencies" :value="option.id">{{ option.name }}</option>
              </select>
            </div>
          </div>
          <div class="col-xs-12 col-sm-5 col-md-4">
            <div class="form-group">
              <label :for="'acc-rate-per-' + i" class="form-label">Per</label>
              <select v-model="acc.ratePer" class="form-control" :id="'acc-rate-per-' + i">
                <option value=""></option>
                <option v-for="option in ratesPer" :value="option.id">{{ option.name }}</option>
              </select>
            </div>
          </div>
          <div class="col-xs-12 col-sm-5 col-md-2">
            <div class="form-group">
              <label :for="'acc-min-' + i" class="form-label">Minimum Charge</label>
              <input type="number" step="0.01" v-model="acc.minimumCost" class="form-control" :id="'acc-min-' + i"/>
            </div>
          </div>
          <div class="col-xs-12 col-sm-2 col-md-2">
            <div class="form-group">
              <label :for="'is-state-' + i" class="form-label">Advice only?</label>
              <div class="material-switch">
                <input :id="'is-state-' + i" type="checkbox" v-model="acc.adviceOnly"/>
                <label :for="'is-state-' + i" class="label-success"></label>
              </div>
            </div>
          </div>
          <div class="col-xs-12">
            <hr>
            <div class="pull-right">
              <div class="btn btn-danger" @click="remove(i, acc)">
                Delete
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import LookupHelperMixin from '../../admin/mixins/Helpers'
  export default {
    name: 'Accessorials',
    props: ['accs'],
    mixins: [ LookupHelperMixin ],
    data () {
      return {
        accessorials: [],
        canEmit: true
      }
    },
    computed: {
      financialCodes () {
        return this.$store.getters['systemOption/financialCodes'].sort((a, b) => {
          return a.name < b.name ? -1 : a.name > b.name ? 1 : 0
        })
      },
      ratesPer () {
        return this.sortedOptions('BREAKPOINT_UNIT')
      }
    },
    watch: {
      accessorials: {
        deep: true,
        handler: function (newVal, oldVal) {
          if (this.canEmit) {
            this.$emit('updating', { accessorials: newVal })
          }
        }
      },
      accs: {
        deep: true,
        handler: function (newVal, oldVal) {
          this.canEmit = false
          if (JSON.stringify(newVal) !== JSON.stringify(this.accessorials)) {
            this.accessorials = []
            newVal.forEach(o => this.accessorials.push(o))
            this.canEmit = true
          }
        }
      }
    },
    methods: {
      unbox (arr) {
        return arr.map(obj => {
          return {
            ...obj,
            financialCode: obj.financialCode !== null && obj.financialCode.hasOwnProperty('id') ? obj.financialCode.id : obj.financialCode,
            ratePer: obj.ratePer !== null && obj.ratePer.hasOwnProperty('id') ? obj.ratePer.id : obj.ratePer,
            rateCurrency: obj.rateCurrency !== null && obj.rateCurrency.hasOwnProperty('id') ? obj.rateCurrency.id : obj.rateCurrency
          }
        })
      },
      addRow () {
        this.accessorials.push({
          financialCode: null,
          description: null,
          rate: 0,
          rateCurrency: null,
          ratePer: null,
          minimumCost: 0,
          adviceOnly: false
        })
        this.$emit('updating', { accessorials: this.accessorials })
      },
      remove (i, acc) {
        this.accessorials.splice(i, 1)
        this.$emit('updating', { accessorials: this.accessorials })
      },
      sortedOptions (type) {
        return this.getSystemOptions(type).sort((a, b) => {
          return a.name < b.name ? -1 : a.name > b.name ? 1 : 0
        })
      }
    }
  }
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/modules/rateassist/components/Accessorials.vue